import { Component } from '@angular/core';
import "phaser";
import Phaser, {Scene} from 'phaser';
import { debug } from 'util';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  phaserGame: Phaser.Game;
  config: Phaser.Types.Core.GameConfig;
  constructor() {
    this.config = {
      title: 'Space-Anomaly',
      
      type: Phaser.AUTO,
      width: window.innerWidth,
      height:window.innerHeight,
      scene: [ BootScene,PreLoad,TitleScreen, Level1 ],
      parent: 'game',
      physics: {
        default: 'arcade',
        arcade: {
          debug:false,
          gravity: { y: 0 }
        },
      }
    };
  }
  ngOnInit() {
    this.phaserGame = new Phaser.Game(this.config);
  }
}
class SceneBuild extends Phaser.Scene {
  constructor() {
    super({ key: 'SceneBuild' });
  }
  init(){
  }
  preload() {
  }
  create() {
  }
  update() {
  }
}

class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' });
  }
  
  init(){
  }

  preload() {
    this.load.image('space', '../assets/nasa-space.png');
  }

  create() {
    this.scene.start('PreLoad');
  }
  
  update() {
  }
}

class PreLoad extends Phaser.Scene {
  constructor() {
    super({ key: 'PreLoad' });
  }
  
  loadText;
  progress;
  border;

  preload() {
    this.LoadBar()

    //  Images
    this.load.image('ship', '../assets/ship.png');
    this.load.image('bullet', '../assets/bullets.png');
    this.load.image('ebullet', '../assets/ebullet.png');
    this.load.image('star', '../assets/star3.png');
    this.load.image('ministar', '../assets/star2.png');
    this.load.image('asteroid1', '../assets/asteroid1.png');
    this.load.image('enemy1', '../assets/enemy1.png');
    this.load.image('enemy2', '../assets/enemy2.png');
    this.load.image('enemy3', '../assets/enemy3.png');
    this.load.image('speedpup', '../assets/orb-green.png');
    this.load.image('powerpup', '../assets/orb-red.png');
    this.load.image('ratepup', '../assets/orb-blue.png');
    this.load.image('smoke', './assets/smoke.png');
    //  Sounds
    this.load.audio('shot', ['../assets/lasershot1.mp3'] );
    this.load.audio('e2fire', ['../assets/e2fire.mp3'] );
    this.load.audio('enemyimpact', ['../assets/impact1.mp3'] );
    this.load.audio('astimpact', ['../assets/impact2.mp3'] );
    this.load.audio('enemyexplode', ['../assets/explosion1.mp3'] );
    this.load.audio('playerexplode', ['../assets/explosion2.mp3'] );
    this.load.audio('ratepup', ['../assets/ratepup.mp3'] );
    this.load.audio('powerpup', ['../assets/powerpup.mp3'] );
    this.load.audio('spacemusic', ['../assets/space.mp3'] );
    this.load.audio('bluespace', ['../assets/bluespace.mp3'] );
  }
  create() {
    this.scene.start('TitleScreen');
  }
  LoadBar(){
    let bg = this.add.image(window.innerWidth/2,window.innerHeight/2,'space');
    bg.displayHeight = window.innerHeight;
    bg.displayWidth = window.innerWidth;
    this.loadText = this.add.text(window.innerWidth/2, 100, 'Space Anomaly', { fontSize: '150px', fill: '#00ff00'});
    this.loadText.setOrigin(.5);
    this.loadText = this.add.text(window.innerWidth/2, window.innerHeight/2-50, 'Loading Game . . .', { fontSize: '80px', fill: '#ff0000'});
    this.loadText.setOrigin(.5);
    this.loadText = this.add.text(window.innerWidth/2, window.innerHeight-90, 'Created by: Michael Feldman', { fontSize: '40px', fill: '#00ff00'});
    this.loadText.setOrigin(.5);
    this.loadText = this.add.text(window.innerWidth/2, window.innerHeight-40, 'Using: Angular8, TypeScript, Phaser3 and FireBase', { fontSize: '40px', fill: '#00ff00'});
    this.loadText.setOrigin(.5);

    let x = 100;
    let y = window.innerHeight/2;
    this.progress = this.add.graphics({ x: x, y: y });
    this.border = this.add.graphics({ x: x, y: y });
    this.load.on('progress', this.OnProgress, this)
  }

  OnProgress(val){
    let w = window.innerWidth - 2*this.progress.x;
    let h = 40;

    this.progress.clear();
    this.progress.fillStyle('0xFF00FF', 1);
    this.progress.fillRect(0, 0, w * val, h);

    this.border.clear();
    this.border.lineStyle(2, '0x4D6592', 1);
    this.border.strokeRect(0, 0, w * val, h, 2);
  }
}

class TitleScreen extends Phaser.Scene {
  constructor() {
    super({ key: 'TitleScreen' });
  }
  gameTitle;
  music1;

  create() {
    let bg = this.add.image(window.innerWidth/2,window.innerHeight/2,'space');
    bg.displayHeight = window.innerHeight;
    bg.displayWidth = window.innerWidth;

    this.scene.stop('Level1');

    this.gameTitle = this.add.text(window.innerWidth/2, 100, 'Space Anomaly', { fontSize: '150px', fill: '#00ff00'});
    this.gameTitle.setOrigin(.5);
    this.gameTitle = this.add.text(window.innerWidth/2, window.innerHeight/2, 'Click 2 Start', { fontSize: '80px', fill: '#ff0000'});
    this.gameTitle.setOrigin(.5);
    this.gameTitle = this.add.text(window.innerWidth/2, window.innerHeight-90, 'Created by: Michael Feldman', { fontSize: '40px', fill: '#00ff00'});
    this.gameTitle.setOrigin(.5);
    this.gameTitle = this.add.text(window.innerWidth/2, window.innerHeight-40, 'Using: Angular8, TypeScript, Phaser3 and FireBase', { fontSize: '40px', fill: '#00ff00'});
    this.gameTitle.setOrigin(.5);

    //this.music1 = this.sound.add('spacemusic', { loop: true });
    //this.music1.play();

    this.CreateMouseInput();
  }
  CreateMouseInput(){
    this.input.on('pointerup', this.StartGame, this);
  }
  StartGame(){
    //this.music1.stop();
    this.scene.start('Level1');
  }
}

class GameOver extends Phaser.Scene {
  constructor() {
    super({ key: 'GameOver' });
  }

  //score;
  gameTitle;
  //init(data){
  //  this.score = data.score;
  //}
  create() {
    let bg = this.add.image(window.innerWidth/2,window.innerHeight/2,'space');
    bg.displayHeight = window.innerHeight;
    bg.displayWidth = window.innerWidth;

    this.gameTitle = this.add.text(window.innerWidth/2, 100, 'Game Over', { fontSize: '150px', fill: '#ff00ff'}); 
    this.gameTitle.setOrigin(.5);
    this.gameTitle = this.add.text(window.innerWidth/2, window.innerHeight/2, 'Click 2 Menu', { fontSize: '80px', fill: '#ff0000'});
    this.gameTitle.setOrigin(.5);
    //this.gameTitle = this.add.text(window.innerWidth/2, window.innerHeight-150, 'Final Score: '+this.score, { fontSize: '80px', fill: '#ff00ff'});
    //this.gameTitle.setOrigin(.5);

    this.CreateMouseInput();
  }
  CreateMouseInput(){
    this.input.on('pointerup', this.StartGame, this);
  }
  StartGame(){
    this.scene.start('TitleScreen');
  }
}

class Level1 extends Phaser.Scene {
  music;

  players;
  player;
  notDead = false;
  gameOver = false;
  gameOverText;
  continueText;
  lives = 2;
  livesText;
  fireSFX;
  playerxplodeSFX;
  score = 0;
  scoreText;
  playerXP = 0;

  enemies;
  nextSpawn;
  spawnRate = 1000;
  enemySpeed;
  impactSFX;
  enemyexplodeSFX;
  enemyCount=0;

  enemies2;
  e2NextSpawn = new Date().getTime();
  e2SpawnRate = 3000;
  enemy2Speed;
  e2FireSFX;

  enemies3;
  e3NextSpawn = new Date().getTime();
  e3SpawnRate = 2000;
  enemy3Speed;

  stars;
  nextStarTime=null;
  starSpeed;
  starType;
  
  
  bullets;
  fireRate = 400;
  fireLevel = 0;
  fireRateText;
  bulletSpeed;
  bulletPower = 10;
  bulletLevel = 0;
  firePowerText;
  lastFired = null;
  speedPUp;
  rateSFX;
  ratePUps;
  powerPUps;
  powerSFX;
  nextpUp = new Date().getTime();
  pUpRate = 20000;
  pUpSpeed;

  EBullets;
  EfireRate = 2000;
  EBulletSpeed;
  EBLastFired = null;
  
  asteroids1;
  astRate = 7000;
  nextAst1;
  smokeParticles;
  astImpactSFX;
  astNum = 1;

  constructor() {
      super({ key: "Level1" })
  }

  getRand(a,b) {
    return Phaser.Math.FloatBetween(a, b);
  }

  init(): void {
  }

  preload() {
   
  }

  create() {
    //  Player
    // @ts-ignore
    var Player = new Phaser.Class({
      Extends: Phaser.GameObjects.Sprite,
      initialize:
      function Player (scene)
      {
        Phaser.GameObjects.Sprite.call(this, scene, 0, 0, 'ship');
      },
      newPlayer: function (x, y,)
      {
        this.angle = 90;
        this.setPosition(x, y);
        this.setActive(true);
        this.setVisible(true);
        this.body.setCircle(42,16,15);
      },
      update: function (time, delta)
      {
      }
    });
    this.players = this.physics.add.group({ 
      classType: Player,
      maxSize: 1,
      runChildUpdate: true
    });
    // Player Bullets
    // @ts-ignore
    var Bullet = new Phaser.Class({
      Extends: Phaser.GameObjects.Sprite,
      initialize:
      function Bullet (scene)
      {
        Phaser.GameObjects.Sprite.call(this, scene, 0, 0, 'bullet');
        this.bulletSpeed = Phaser.Math.GetSpeed(700, 1); 
      },
      fire: function (x, y,)
      {
        this.setPosition(x, y);
        this.setActive(true);
        this.setVisible(true);
      },
      update: function (time, delta)
      {
          this.x += this.bulletSpeed * delta;
          if (this.x > window.innerWidth){
             this.destroy();
          }
      }
    });
    this.bullets = this.physics.add.group({ 
      classType: Bullet,
      maxSize: 50,
      runChildUpdate: true
    });
    // Enemy Bullets
    // @ts-ignore
    var EBullet = new Phaser.Class({
      Extends: Phaser.GameObjects.Sprite,
      initialize:
      function EBullet (scene)
      {
        Phaser.GameObjects.Sprite.call(this, scene, 0, 0, 'ebullet');
        this.EBulletSpeed = Phaser.Math.GetSpeed(600, 1); 
      },
      fire: function (x, y,)
      {
        this.angle = 180;
        this.setScale(.3);
        this.setPosition(x, y);
        this.setActive(true);
        this.setVisible(true);
      },
      update: function (time, delta)
      {
          this.x -= this.EBulletSpeed * delta;
          if (this.x < -20){
             this.destroy();
          }
      }
    });
    this.EBullets = this.physics.add.group({ 
      classType: EBullet,
      maxSize: 5,
      runChildUpdate: true
    });
    //  Stars
    // @ts-ignore
    var Star = new Phaser.Class({
      Extends: Phaser.GameObjects.Sprite,
      initialize:
      function Star (scene)
      {
        if(Phaser.Math.RND.integerInRange(1,8)!=5){
          Phaser.GameObjects.Sprite.call(this, scene, 0, 0, 'ministar');
          this.starType = 'mini';
        }
        else{
          Phaser.GameObjects.Sprite.call(this, scene, 0, 0, 'star');
          this.starType = 'star';
        }
        this.starSpeed = Phaser.Math.GetSpeed(50, 1);
        
      },
      spawn: function (x,y)
      {
        this.setPosition(x, y);
        this.setActive(true);
        this.setVisible(true);
        this.setDepth(-1);
        if(this.starType == 'mini')
          this.health = Phaser.Math.FloatBetween(0.1,0.17);
        else
          this.health = Phaser.Math.FloatBetween(0.2,0.3);
      },
      update: function (time, delta)
      {
        this.x -= this.health * delta;
        if (this.x < 20){
          this.destroy();
        }
      }
    });
    this.stars = this.add.group({ 
      classType: Star,
      maxSize: 50,
      runChildUpdate: true
    });
    //  Enemies
    // @ts-ignore
    var Enemy1 = new Phaser.Class({
      Extends: Phaser.GameObjects.Image,
      initialize:
      function Enemy1 (scene)
      {
        Phaser.GameObjects.Image.call(this, scene, 0, 0, 'enemy1');
        this.enemySpeed = Phaser.Math.GetSpeed(400, 1);
      },
      spawn: function (x, y)
      {
        this.setScale(.2);
        this.setPosition(x, y);
        this.setActive(true);
        this.setVisible(true);
        this.body.setCircle(220,40,40);
        this.health = 30;
        this.props = {};
        this.props.turn = 0.5;
      },
      update: function (time, delta)
      {
        this.angle += this.props.turn;
        this.props.turn += 0.04;
        this.x -= this.enemySpeed * delta;
        if (this.x < -20){
          this.destroy();
        }
      }
    });
    this.enemies = this.physics.add.group({ 
      classType: Enemy1,
      maxSize: 5,
      runChildUpdate: true
    });
    //  Enemies 2
    // @ts-ignore
    var Enemy2 = new Phaser.Class({
      Extends: Phaser.GameObjects.Image,
      initialize:
      function Enemy2 (scene)
      {
        Phaser.GameObjects.Image.call(this, scene, 0, 0, 'enemy2');
        this.enemy2Speed = Phaser.Math.GetSpeed(150, 1);
      },
      spawn: function (x, y, eb, sound)
      {
        this.angle = 270;
        this.setScale(.1);
        this.setPosition(x, y);
        this.setActive(true);
        this.setVisible(true);
        this.body.setCircle(270,25,95);
        this.health = 60;
        this.props = {};
        this.props.eb = eb;
        this.props.e2FireSFX = sound;
        this.props.EBLastFired = new Date().getTime();
        this.props.EFireRate = Phaser.Math.FloatBetween(1000, 3000);
        if(this.y > window.innerHeight/2){
          this.props.up = true;
        }
        else{
          this.props.up = false;
        }
      },
      update: function (time, delta)
      {
        if ((this.props.EBLastFired+this.props.EFireRate<new Date().getTime())){
          var eBullet = this.props.eb.get();
          if (eBullet){
            this.props.e2FireSFX.play();
            eBullet.fire(this.x - 40, this.y);
            this.props.EBLastFired = new Date().getTime();
            this.props.EFireRate = Phaser.Math.FloatBetween(2000, 4000);
          }
        }
        if(Phaser.Math.FloatBetween(0, 10)>9.90){
          this.props.up = !this.props.up;
        }
        if(this.props.up){
          this.y -= this.enemy2Speed/3.5 * delta;
          if(this.y < 70)
            this.props.up = false;
        }
        else{
          this.y += this.enemy2Speed/3 * delta;
          if(this.y > window.innerHeight - 70)
            this.props.up = true;
        }
        this.x -= this.enemy2Speed * delta;
        if (this.x < -20){
          this.destroy();
        }
      }
    });
    this.enemies2 = this.physics.add.group({ 
      classType: Enemy2,
      maxSize: 5,
      runChildUpdate: true
    });
    //  Enemies 3
    // @ts-ignore
    var Enemy3 = new Phaser.Class({
      Extends: Phaser.GameObjects.Image,
      initialize:
      function Enemy3 (scene)
      {
        Phaser.GameObjects.Image.call(this, scene, 0, 0, 'enemy3');
        this.enemy3Speed = Phaser.Math.GetSpeed(250, 1);
      },
      spawn: function (x, y, eb, sound)
      {
        this.angle = 270;
        this.setScale(.2);
        this.setPosition(x, y);
        this.setActive(true);
        this.setVisible(true);
        this.body.setCircle(150,38,40);
        this.health = 45;
        this.props = {};
        this.props.eb = eb;
        this.props.e2FireSFX = sound;
        this.props.EBLastFired = new Date().getTime();
        this.props.EFireRate = Phaser.Math.FloatBetween(1000, 3000);
        if(this.y > window.innerHeight/2){
          this.props.up = true;
        }
        else{
          this.props.up = false;
        }
      },
      update: function (time, delta)
      {
        if ((this.props.EBLastFired+this.props.EFireRate<new Date().getTime())){
          var eBullet = this.props.eb.get();
          if (eBullet){
            this.props.e2FireSFX.play();
            eBullet.fire(this.x - 40, this.y);
            this.props.EBLastFired = new Date().getTime();
            this.props.EFireRate = Phaser.Math.FloatBetween(2000, 4000);
          }
        }
        
        if(this.props.up){
          this.y -= this.enemy3Speed/3.5 * delta;
          if(this.y < 70)
            this.props.up = false;
        }
        else{
          this.y += this.enemy3Speed/3 * delta;
          if(this.y > window.innerHeight - 70)
            this.props.up = true;
        }
        this.x -= this.enemy3Speed * delta;
        if (this.x < -20){
          this.destroy();
        }
      }
    });
    this.enemies3 = this.physics.add.group({ 
      classType: Enemy3,
      maxSize: 5,
      runChildUpdate: true
    });
    //  Asteroids
    // @ts-ignore
    var Asteroid1 = new Phaser.Class({
      Extends: Phaser.GameObjects.Image,
      initialize:
      function Asteroid1 (scene)
      {
        Phaser.GameObjects.Image.call(this, scene, 0, 0, 'asteroid1');
        this.enemySpeed = Phaser.Math.GetSpeed(400, 1);
      },
      spawn: function (x, y, dir)
      {
        this.setScale(1.2);
        this.setPosition(x, y);
        this.setActive(true);
        this.setVisible(true);
        this.body.setCircle(15,0,0);
        this.health = dir;
        this.props = {};
        this.props.angle = Phaser.Math.FloatBetween(1, 3);
      },
      update: function (time, delta)
      {
        this.angle -= 0.8;
        switch (this.health){
          case 1:
              this.x += this.enemySpeed/(this.props.angle+2) * delta;
              this.y -= this.enemySpeed/2 * delta;
              if (this.y < -20){
                this.destroy();
              }
            break;
          case 2:
              this.x -= this.enemySpeed/this.props.angle * delta;
              this.y -= this.enemySpeed/2 * delta;
              if (this.y < -20){
                this.destroy();
              }
            break;
          case 3:
              this.x -= this.enemySpeed/this.props.angle * delta;
              this.y += this.enemySpeed/2 * delta;
              if (this.y > window.innerHeight+20){
                this.destroy();
              }
            break;
          case 4:
              this.x += this.enemySpeed/(this.props.angle+2) * delta;
              this.y += this.enemySpeed/2 * delta;
              if (this.y > window.innerHeight+20){
                this.destroy();
              }
            break;
        }
      }
    });
    this.asteroids1 = this.physics.add.group({ 
      classType: Asteroid1,
      maxSize: this.astNum,
      runChildUpdate: true
    });
    //  Rate Power Up
    // @ts-ignore
    var RatePUp = new Phaser.Class({
      Extends: Phaser.GameObjects.Image,
      initialize:
      function RatePUp (scene)
      {
        Phaser.GameObjects.Image.call(this, scene, 0, 0, 'ratepup');
        this.pUpSpeed = Phaser.Math.GetSpeed(600, 1);
      },
      spawn: function (x, y)
      {
        this.setScale(1.2);
        this.setPosition(x, y);
        this.setActive(true);
        this.setVisible(true);
      },
      update: function (time, delta)
      {
        this.x -= this.pUpSpeed * delta;
        if (this.x < -20){
          this.destroy();
        }
      }
    });
    this.ratePUps = this.physics.add.group({ 
      classType: RatePUp,
      maxSize: 1,
      runChildUpdate: true
    });
    //  Power Power Up
    // @ts-ignore
    var PowerPUp = new Phaser.Class({
      Extends: Phaser.GameObjects.Image,
      initialize:
      function PowerPUp (scene)
      {
        Phaser.GameObjects.Image.call(this, scene, 0, 0, 'powerpup');
        this.pUpSpeed = Phaser.Math.GetSpeed(600, 1);
      },
      spawn: function (x, y)
      {
        this.setScale(1.2);
        this.setPosition(x, y);
        this.setActive(true);
        this.setVisible(true);
      },
      update: function (time, delta)
      {
        this.x -= this.pUpSpeed * delta;
        if (this.x < -20){
          this.destroy();
        }
      }
    });
    this.powerPUps = this.physics.add.group({ 
      classType: PowerPUp,
      maxSize: 1,
      runChildUpdate: true
    });
    
    
    //  Set Sounds
    this.fireSFX = this.sound.add('shot', { loop: false });
    this.rateSFX = this.sound.add('ratepup', { loop: false });
    this.e2FireSFX = this.sound.add('e2fire', { loop: false })
    this.powerSFX = this.sound.add('powerpup', { loop: false });
    this.impactSFX = this.sound.add('enemyimpact', { loop: false });
    this.astImpactSFX = this.sound.add('astimpact', { loop: false });
    this.enemyexplodeSFX = this.sound.add('enemyexplode', { loop: false });
    this.playerxplodeSFX = this.sound.add('playerexplode', { loop: false });
    this.music = this.sound.add('bluespace', { loop: true });
    this.music.play();

    // Set Hud Text
    let livesShip = this.add.image(30,30, 'ship');
    livesShip.angle = 90;
    livesShip.setScale(.5);
    let powerIcon = this.add.image(260,30, 'powerpup');
    powerIcon.setScale(1.5);
    let rateIcon = this.add.image(150,30, 'ratepup');
    rateIcon.setScale(1.5);
    this.scoreText = this.add.text(750, 16, 'Score:0', { fontSize: '32px', fill: '#129900'});
    this.livesText = this.add.text(60, 16, 'x2', { fontSize: '32px', fill: '#129900'});
    this.fireRateText = this.add.text(168, 16, 'x0', { fontSize: '32px', fill: '#129900'});
    this.firePowerText = this.add.text(278, 16, 'x0', { fontSize: '32px', fill: '#129900'});
    
    this.smokeParticles = this.add.particles('smoke').createEmitter({
      x: 1600,
      y: 200,
      angle: { min: 170, max: 190 },
      scale: { start: 0.4, end: 0.2 },
      blendMode: 'ADD',
      lifespan: 500,
      on: false
    });
    // Create Some Random Stars
    for (let i = 0; i < 20; i++) {
      let star = this.stars.get();
      if (star){
        star.spawn(this.getRand(10, window.innerWidth), this.getRand(10, window.innerHeight));
      }
    }

    
    this.input.mouse.disableContextMenu();
    

    this.physics.add.overlap(this.enemies, this.bullets, this.hitEnemy, null, this);
    this.physics.add.overlap(this.enemies2, this.bullets, this.hitEnemy2, null, this);
    this.physics.add.overlap(this.enemies3, this.bullets, this.hitEnemy3, null, this);
    this.physics.add.overlap(this.asteroids1, this.bullets, this.hitAst1, null, this);
  }

  update(delta) {
    //  Spawn Stars
    if(this.nextStarTime == null || this.nextStarTime<new Date().getTime()){
      var star = this.stars.get();
      if (star){
        star.spawn(window.innerWidth + 40, this.getRand(10, window.innerHeight));
        this.nextStarTime = new Date().getTime() + this.getRand(500,1500);
      }
    }
    //  Mouse click
    if ((this.input.activePointer.isDown && this.notDead && !this.gameOver) && (this.lastFired == null || this.lastFired+this.fireRate<new Date().getTime())){
      var bullet = this.bullets.get();
      if (bullet){
        this.fireSFX.play();
        bullet.fire(this.player.x + 40, this.player.y);
        this.lastFired = new Date().getTime();
        this.score--;
        this.scoreText.setText('Score:' + this.score);
      }
    }
    else if(this.input.activePointer.isDown && !this.notDead && !this.gameOver && this.lives>=0){
      this.enemies.clear(true, true);
      this.enemies2.clear(true, true);
      this.enemies3.clear(true, true);
      this.EBullets.clear(true, true);
      this.asteroids1.clear(true, true);
      this.player = this.players.get();
      this.player.newPlayer(200,window.innerHeight/2);
      this.nextpUp = new Date().getTime()+this.getRand(20000,32000);
      this.nextSpawn = new Date().getTime()+this.getRand(1000,2000);
      this.nextAst1 = new Date().getTime()+this.getRand(5000,10000);
      this.physics.add.overlap(this.enemies, this.player, this.hitPlayer, null, this);
      this.physics.add.overlap(this.enemies2, this.player, this.hitPlayer, null, this);
      this.physics.add.overlap(this.enemies3, this.player, this.hitPlayer, null, this);
      this.physics.add.overlap(this.EBullets, this.player, this.hitPlayer, null, this);
      this.physics.add.overlap(this.ratePUps, this.player, this.GetRatePUp, null, this);
      this.physics.add.overlap(this.asteroids1, this.player, this.hitPlayer, null, this);
      this.physics.add.overlap(this.powerPUps, this.player, this.GetPowerPUp, null, this);
      this.notDead = true;
    //  this.input.on('pointerup', this.makePlayer(this.players));
    
    }
    else if(this.gameOver){
      
      this.continueText.on('pointerup', ()=>{
        this.enemyCount = 0;
        this.gameOver = false;
        this.notDead = false;
        this.lives = 2;
        this.fireRate = 400;
        this.fireLevel = 0;
        this.bulletPower = 10;
        this.bulletLevel = 0;
        this.playerXP = 0;
        this.score = 0;
        this.e3SpawnRate = 2000;
        this.e2SpawnRate = 3000;
        this.spawnRate = 1000;
        this.astNum = 1; 
        this.music.stop();
        this.scene.start('TitleScreen')
      });
    }
    //  Mouse Control
    if(this.notDead){
      this.input.on('pointermove', function (pointer) {
        this.player.x = Phaser.Math.Clamp(pointer.x, 52, window.innerWidth / 2);
        this.player.y = Phaser.Math.Clamp(pointer.y, 52, window.innerHeight - 52);
      }, this);
    }
    //  Enemy Spawn
    if ((this.spawnRate+this.nextSpawn<new Date().getTime())&&this.notDead){
      if(this.enemyCount == 10)
        this.spawnRate = 0;
      var enemy = this.enemies.get();
      if (enemy){
        enemy.spawn(window.innerWidth + 40, this.getRand(52, window.innerHeight-52));
        this.nextSpawn = new Date().getTime()+this.getRand(1000,2000);
        this.physics.add.overlap(this.enemies, this.player, this.hitPlayer, null, this);
        this.enemyCount++;
      }
    }
    //  Enemy2 Spawn
    if ((this.e2SpawnRate+this.e2NextSpawn<new Date().getTime())&&this.notDead&&this.enemyCount > 70){
      if(this.enemyCount > 150 && this.enemyCount<170)
        this.e3SpawnRate = 0;
        if(this.enemyCount>100 && this.enemyCount<120){
          this.astRate = 0;
          this.astNum = 2;
        }
        
      var enemy2 = this.enemies2.get();
      if (enemy2){
        enemy2.spawn(window.innerWidth + 40, this.getRand(52, window.innerHeight-52), this.EBullets, this.e2FireSFX);
        this.e2NextSpawn = new Date().getTime()+this.getRand(1000,2000);
        this.physics.add.overlap(this.enemies2, this.player, this.hitPlayer, null, this);
        this.enemyCount++;
      }
    }
    //  Enemy3 Spawn
    if ((this.e3SpawnRate+this.e3NextSpawn<new Date().getTime())&&this.notDead&&this.enemyCount >= 20){
      if(this.enemyCount > 300 && this.enemyCount<320)
        this.e2SpawnRate = 0;
      if(this.enemyCount > 400 && this.enemyCount < 420)
        this.astNum = 4;
      var enemy3 = this.enemies3.get();
      if (enemy3){
        enemy3.spawn(window.innerWidth + 40, this.getRand(52, window.innerHeight-52), this.EBullets, this.e2FireSFX);
        this.e3NextSpawn = new Date().getTime()+this.getRand(1000,2000);
        this.physics.add.overlap(this.enemies3, this.player, this.hitPlayer, null, this);
        this.enemyCount++;
      }
    }
    //  Power Up Spawn
    if((this.pUpRate + this.nextpUp<new Date().getTime())&&this.notDead){
      let pUpType = Phaser.Math.RND.integerInRange(1,2);
      switch (pUpType){
        case 1:
            var ratePUp = this.ratePUps.get();
            if(ratePUp){
              ratePUp.spawn(window.innerWidth, this.getRand(10, window.innerHeight-10));
              this.physics.add.overlap(this.ratePUps, this.player, this.GetRatePUp, null, this);
            }
          break;
        case 2:
            var powerPUp = this.powerPUps.get();
            if(powerPUp){
              powerPUp.spawn(window.innerWidth, this.getRand(10, window.innerHeight-10));
              this.physics.add.overlap(this.powerPUps, this.player, this.GetPowerPUp, null, this);
            }
          break;
      }
      this.nextpUp = new Date().getTime() + this.getRand(20000,32000);
    }
    //  Asteroid1 Spawn
    if(this.nextAst1<new Date().getTime() && this.notDead && this.enemyCount>=10){
      var ast1 = this.asteroids1.get();
      if(ast1){
        let dir = Phaser.Math.RND.integerInRange(1,4);
        if(dir<3){
          ast1.spawn(this.getRand(200, (window.innerWidth-200)), window.innerHeight-10, dir);
          this.nextAst1 = new Date().getTime()+this.getRand(5000,10000);
        }
        else{
          ast1.spawn(this.getRand(200, (window.innerWidth-200)), -10, dir);
          this.nextAst1 = new Date().getTime()+this.getRand(3000,this.astRate);
        }
        this.physics.add.overlap(this.asteroids1, this.player, this.hitPlayer, null, this);
        this.physics.add.overlap(this.asteroids1, this.enemies, this.objCrush, null, this);
        this.physics.add.overlap(this.asteroids1, this.enemies2, this.objCrush, null, this);
        this.physics.add.overlap(this.asteroids1, this.enemies3, this.objCrush, null, this);
      }
    }
  }

  //
  hitEnemy (enemy, bullet){
    this.impactSFX.play();
    bullet.destroy();
    enemy.health -= this.bulletPower;
    if(enemy.health <= 0){
      this.enemyexplodeSFX.play();
      enemy.destroy();
      this.score +=10;
      this.playerXP +=1;
      this.scoreText.setText(`Score: ${this.score}`);
    }
  }

  hitEnemy2 (enemy, bullet){
    this.impactSFX.play();
    bullet.destroy();
    enemy.health -= this.bulletPower;
    if(enemy.health <= 0){
      this.enemyexplodeSFX.play();
      enemy.destroy();
      this.score +=100;
      this.playerXP +=3;
      this.scoreText.setText(`Score: ${this.score}`);
    }
  }
  hitEnemy3 (enemy, bullet){
    this.impactSFX.play();
    bullet.destroy();
    enemy.health -= this.bulletPower;
    if(enemy.health <= 0){
      this.enemyexplodeSFX.play();
      enemy.destroy();
      this.score +=50;
      this.playerXP +=3;
      this.scoreText.setText('Score:' + this.score);
    }
  }

  hitAst1 (enemy, bullet){
    this.astImpactSFX.play();
    bullet.destroy();
  }

  hitPlayer (enemy, player){
    this.playerxplodeSFX.play();
    player.destroy();
    enemy.destroy();
    
    this.lives--;
    if(this.lives == -1){
      this.gameOver = true;
      this.physics.pause;
      this.gameOverText = this.add.text(window.innerWidth/2, window.innerHeight/2-50, 'Game Over', { fontSize: '100px', fill: '#ff0000'})
      .setOrigin(.5);
      this.continueText = this.add.text(window.innerWidth/2, window.innerHeight/2+50, 'Click here to continue', { fontSize: '50px', fill: '#ff0000'})
      .setOrigin(.5)
      .setInteractive()
      .on('pointerover', () => this.continueText.setStyle({ fill: '#0f0'}))
      .on('pointerout', () => this.continueText.setStyle({ fill: '#ff0000' }));
    }
    else{
      this.notDead = false;
      this.livesText.setText('x' + this.lives);
    }
  }

  objCrush (obj1, obj2){
    this.enemyexplodeSFX.play();
    obj1.destroy();
    obj2.destroy();
  }

  GetRatePUp (player, pUp){
    this.rateSFX.play();
    pUp.destroy();
    if(this.fireRate>100){
      this.fireRate -= 20;
      this.fireLevel++;
      this.fireRateText.setText('x' + this.fireLevel);
    }
    else
      this.score += 1000;
    this.scoreText.setText('Score:' + this.score);
  }

  GetPowerPUp (player, pUp){
    this.powerSFX.play();
    pUp.destroy();
    if(this.bulletPower<85){
      this.bulletPower += 4;
      this.bulletLevel++;
      this.firePowerText.setText('x' + this.bulletLevel);
    }
    else
      this.score += 1000;
    this.scoreText.setText('Score:' + this.score);
  }

}


